export const localConfig = {
  REACT_APP_AZURE_CLIENT_ID: '4f021978-61e5-460b-be42-01b34e8edc3d',
  REACT_APP_API_URL: 'https://as-mg-dev1-t1-weu-invdesktop-api-01.azurewebsites.net',
  REACT_NEXUS_API_URL: 'https://as-mg-dev1-t1-weu-agents-01.azurewebsites.net',
  REACT_SEMANTIC_API_URL: 'https://as-mg-dev1-t1-weu-semanticdata-01.azurewebsites.net',
  REACT_SMARTDOCS_API_URL: 'https://as-mg-dev1-t1-weu-docai-01.azurewebsites.net',
  REACT_APP_AZURE_REDIRECT_URL: 'http://localhost:3000',
  REACT_APP_AZURE_AUTHORITY:
    'https://login.microsoftonline.com/aa42167d-6f8d-45ce-b655-d245ef97da66',
  REACT_APP_AZURE_SCOPE: 'api://2a8c1f76-b39b-4dd2-8200-f4eb40a751b1/user_impersonation',
  REACT_NEXUS_AZURE_SCOPE: 'api://ab98ed05-b8ad-4621-9bb3-ad04e9847116/user_impersonation',
  ALI_CHAT_SOURCE_ID: 'c2f02354-db44-44df-9d34-168f5772991b',
  SPOTFIRE_HOST_NAME: 'spotfire.dev.mandg.local',
  APP_INSIGHTS_CONNECTION_STR: '',
  STATIC_ASSETS_URL: 'https://samgdev1t1neuinvd01.blob.core.windows.net/desktopportal/assets'
}

export const getConfig = () =>
  process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
    ? localConfig
    : window.config
